export default __webpack_public_path__ + "images/SkyUp.ef1f204.png";